module.exports = __webpack_public_path__ + "img/calendarIcon.fbbfbc30.svg";